import {DceComponent} from "dce-engine";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import Dce from "dce-engine/lib/decorators/Dce";

interface ClipboardProps {
    txt: string
}

@Dce("Clipboard")
export default class Clipboard extends DceComponent<ClipboardProps> {

    constructor(elem: DceHTMLElement, props: ClipboardProps) {
        super(elem, props);

        this.elem.style.transition = "opacity 0.2s ease-in-out";

        this.elem.addEventListener('click', e => {
            var el = document.createElement('textarea');
            el.style.position = "absolute";
            el.style.left = "-10000px";
            el.value = this.props.txt;
            el.setAttribute('readonly', '');
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);

            elem.style.opacity = "0";

            setTimeout(() => {
                this.elem.style.opacity = "1"
            }, 300);

        });

    }

}